import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

import dexfiLogo from './image/dexfiLogo.png';

const useStyles = makeStyles()((theme) => ({
  footer: {
    background: theme.palette.custom.background.dark,
    marginTop: 'auto',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },
  logo: {
    height: 128,
    width: 128,
  },
  box: {
    ...dFlex('space-between', 'center'),
    paddingBottom: 40,
    paddingTop: 40,
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
      flexDirection: 'column',
      gap: 16,
    },
  },
  right: {
    ...dFlex('unset', 'flex-end'),
    flexDirection: 'column',
    gap: '16px',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  left: {
    maxWidth: 285,
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  footerSocials: {
    ...dFlex('flex-end', 'center'),
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  icon: {
    svg: {
      path: {
        fill: theme.palette.custom.elements.primary,
      },
    },
  },
  link: {
    ...dFlex('center', 'center'),
    gap: '4px',

    svg: {
      color: theme.palette.custom.text.dark,
    },
  },
}));

export default useStyles;
